import { useState } from 'react';
import {Tab,Tabs} from 'react-bootstrap';
import ApiBusqueda360 from "../../fetchs/ApiBusqueda360";
import ApiBusquedaDocumentacion from "../../fetchs/ApiBusquedaDocumentacion";
export default function ControlledTabs(param){
    const [key, setKey] = useState(0);
    const [apiDataProgr, setApiDataProgramas] = useState([]);
    const [selectedIndex, setSelectedIndex] = useState(0)
    let var_ingles = "es";
    if (window.location.href.indexOf("en.") > -1) {
        var_ingles = "en";
    }
    let paramDataProgra = {};
    let paramDataTemas = {};
    let paramDataIndicador = {};
    let paramDataDoc ={}
    let apiDataTemas = "";
    let apiDataIndicadores ="";
    let apiDataProgramas ="";
    let apiDataDoc = "";
    if (param.coleccion == "Indicadores"){
      paramDataProgra = { //Temas
        BusTema: 11,
        BusPrograma: 0,
        BusIndicador: param.idIndicador,
        PaginaInicio: 0,
        PaginaFin: 0,
        Idioma: param.var_ingles
      };
      paramDataTemas = {// programas
        BusTema: 0,
        BusPrograma: 11,
        BusIndicador: param.idIndicador,
        PaginaInicio: 0,
        PaginaFin: 0,
        Idioma: param.var_ingles
      };
      apiDataProgramas = ApiBusqueda360("/app/api/buscadorcore/v1/busquedaBusqueda360/", paramDataProgra)
      apiDataTemas = ApiBusqueda360("/app/api/buscadorcore/v1/busquedaBusqueda360/", paramDataTemas)
    }
    if (param.coleccion == "Temas"){
      paramDataProgra = {
        BusTema: param.idTema,
        BusPrograma: 0,
        BusIndicador: 0,
        PaginaInicio: 0,
        PaginaFin: 0,
        Idioma: param.var_ingles
      };
      paramDataIndicador = {
        BusTema: param.idTema,
        BusPrograma: 0,
        BusIndicador: 1,
        PaginaInicio: 0,
        PaginaFin: 0,
        Idioma: param.var_ingles
      };
      paramDataDoc = {
        busqueda: param.busqueda,
        paginaInicio: 0,
        paginaFin: 0,
        paramPrograma: param.urlPrograma,
        idioma: param.var_ingles,
        coleccion: param.coleccion
      };
      apiDataProgramas = ApiBusqueda360("/app/api/buscadorcore/v1/busquedaBusqueda360/", paramDataProgra)
      apiDataIndicadores = ApiBusqueda360("/app/api/buscadorcore/v1/busquedaBusqueda360/", paramDataIndicador)
      apiDataDoc = ApiBusquedaDocumentacion("/app/api/buscadorcore/v1/busquedaDocumentos/", paramDataDoc)
    }
    if (param.coleccion == "Programas"){
      paramDataTemas = {
        BusTema: 0,
        BusPrograma: param.idPrograma,
        BusIndicador: 0,
        PaginaInicio: 0,
        PaginaFin: 0,
        Idioma: param.var_ingles
      };
      paramDataIndicador = {
        BusTema: 0,
        BusPrograma: param.idPrograma,
        BusIndicador: 1,
        PaginaInicio: 0,
        PaginaFin: 0,
        Idioma: param.var_ingles
      };
      paramDataDoc = {
        busqueda: param.busqueda,
        paginaInicio: 0,
        paginaFin: 0,
        paramPrograma: param.urlPrograma,
        idioma: param.var_ingles,
        coleccion: param.coleccion
      };
      apiDataTemas = ApiBusqueda360("/app/api/buscadorcore/v1/busquedaBusqueda360/", paramDataTemas)
      apiDataIndicadores = ApiBusqueda360("/app/api/buscadorcore/v1/busquedaBusqueda360/", paramDataIndicador)
      apiDataDoc = ApiBusquedaDocumentacion("/app/api/buscadorcore/v1/busquedaDocumentos/", paramDataDoc)
    }
    if ((param.coleccion == "Investigacion") || (param.coleccion == "Infraestructura")){
      paramDataDoc = {
        busqueda: param.busqueda,
        paginaInicio: 0,
        paginaFin: 0,
        paramPrograma: param.url,
        idioma: param.var_ingles,
        coleccion: param.coleccion
      };
      apiDataDoc = ApiBusquedaDocumentacion("/app/api/buscadorcore/v1/busquedaDocumentos/", paramDataDoc)
    }
  function imagen(url){
    let urlImagen="";

    if (url.includes("pdf"))
    {
      urlImagen = "/img/ico/ico_pdf.png";
    }
    if (url.includes("zip"))
    {
      urlImagen = "/img/ico/ico_zip.png";
    }
    if (url.includes("glosario"))
    {
        urlImagen = "/img/ico/ico_xlsx.png";
    }
    return urlImagen
  }
return(
      <> 
        {
          (
            (param.coleccion != "Temas" && param.coleccion != "Investigacion" && param.coleccion != "Infraestructura" && !apiDataTemas.loading && (apiDataTemas.data).length > 0 )|| 
            (param.coleccion != "Programas" && param.coleccion != "Investigacion" && param.coleccion != "Infraestructura" && !apiDataProgramas.loading && (apiDataProgramas.data).length > 0 )|| 
            (param.coleccion != "Indicadores" && param.coleccion != "Investigacion" && param.coleccion != "Infraestructura" && !apiDataIndicadores.loading && (apiDataIndicadores.data).length > 0) ||
            (param.coleccion != "Indicadores" && !apiDataDoc.loading && (apiDataDoc.data).length > 0)
            )? (
            <>
              <div className="col-md-11" style={{marginTop:"10px", paddingLeft:"0px"}}  id={"busqueda360-" + param.id}>
                <span id={"tituloBusqueda-" + param.id} style={{textAlign:"justify"}} > 
                  {var_ingles =="es"?"Información relacionada en:":"Related information in:"}        
                </span>
              </div>
              <div className="col-md-10" style={{marginTop:"10px", paddingLeft:"0px"}} id={"pestana-" + param.id}>
                <div>
                  <Tabs id="controlled-tab-example" onChange={setSelectedIndex} navbarScroll="true">
                    {
                      (param.coleccion != "Indicadores" && !apiDataDoc.loading && (apiDataDoc.data).length > 0)? (
                        <Tab eventKey="documentacion" title={ var_ingles =="es"?"Documentos" + " (" + (!apiDataDoc.loading? (apiDataDoc.data).length : "" ) + ")": "Documents"  + " (" + (!apiDataDoc.loading? (apiDataDoc.data).length : "" ) + ")"} >
                          { !apiDataDoc.loading && apiDataDoc.data.map((datos) => (
                            <div className = "col-xs-12 col-sm-12 todo" key={datos.ID} id={"resultadoGeneral-Documentos-" + datos.ID}>
                              <div style={{paddingLeft: "0px!important"}}  id={"titulo-Documentos-" + datos.ID}>
                                <li id={"li_row-primero-"+ datos.ID} style={{paddingBottom:"5px", textIndent:"-18px", paddingLeft:"15px"}} >{datos.TITULO_DOCUMENTOS}
                                  <a target="_blank" href={datos.URL_DOC} id={"rutaDocument-primero-" + datos.ID}>
                                    <img src={imagen(datos.URL_DOC)} style={{paddingLeft:"5px",paddingRight:"5px"}} alt=''/>
                                  </a>
                                  <small>{ (datos.TAMANO_DOC != "")? datos.TAMANO_DOC  : ""}</small>  
                                </li>
                              </div>
                            </div>
                          ))}
                        </Tab>)
                      :""
                    }
                    {
                      (param.coleccion != "Indicadores" && param.coleccion != "Investigacion" && param.coleccion != "Infraestructura" && !apiDataIndicadores.loading && (apiDataIndicadores.data).length > 0)? (
                        (param.coleccion != "Indicadores" && (param.coleccion != "Investigacion") && (param.coleccion != "Infraestructura"))? 
                        <Tab eventKey="indicadores" title={var_ingles =="es"?"Indicadores" + " (" + (!apiDataIndicadores.loading? (apiDataIndicadores.data).length : "" ) + ")": "Indicators" + " (" + (!apiDataIndicadores.loading? (apiDataIndicadores.data).length : "" ) + ")"} >
                          { !apiDataIndicadores.loading && apiDataIndicadores.data.map((datos) => (
                            <div className = "col-xs-12 col-sm-12 todo" key={datos.ID} style={{marginBottom:"5px"}} id={"resultadoGeneral-Indicadores-" + datos.ID}>
                              <div style={{paddingLeft: "0px!important", display:"inline-flex"}}  id={"titulo-" + datos.ID}>
                                  <a target="_blank" href={"/app/indicadores/?ind=" + datos.INDICADOR} id={"TituloHip-" + datos.ID}> 
                                    <div  id={"gadget-" + datos.ID}>
                                      {datos.TITULO_INDICADOR + " (" + datos.UNIDAD_MEDIDA + ")"}
                                    </div>
                                  </a>
                              </div>
                            </div>
                          ))}
                        </Tab>
                        :""
                      ):""
                    }
                    {
                      param.coleccion == "Indicadores" || param.coleccion == "Temas"? (
                        (!apiDataProgramas.loading && (apiDataProgramas.data).length > 0)? (
                          <Tab eventKey="programas" title={var_ingles =="es"?"Programación de información" + " (" + (!apiDataProgramas.loading? (apiDataProgramas.data).length : "" ) + ")": "Information programs" + " (" + (!apiDataProgramas.loading? (apiDataProgramas.data).length : "" ) + ")"}>
                              { !apiDataProgramas.loading && apiDataProgramas.data.map((datos) => (
                                <div className = "col-xs-12 col-sm-12 todo" key={datos.ID} style={{marginBottom:"5px"}} id={"resultadoGeneral-Programas-" + datos.ID}>
                                  <div style={{paddingLeft: "0px!important", display:"inline-flex"}}  id={"titulo-" + datos.ID}>
                                    {
                                      datos.PROGRAMAS_URL !== "" ?
                                        <a target="_blank" href={datos.PROGRAMAS_URL} id={"TituloHip-" + datos.ID}> 
                                          <div  id={"gadget-" + datos.ID}>
                                            {datos.TITULO_PROGRAMAS} 
                                          </div>
                                        </a>
                                      :
                                        <div  id={"gadget-" + datos.ID}>
                                            {datos.TITULO_PROGRAMAS } 
                                        </div>
                                    }
                                  </div>
                                </div>
                              ))}
                          </Tab>)
                        :""
                      ):""
                    }
                    {
                      param.coleccion == "Indicadores" || param.coleccion == "Programas"? (
                        (!apiDataTemas.loading && (apiDataTemas.data).length > 0)? (
                          <Tab eventKey="temas" title={var_ingles =="es"?"Temas" + " (" + (!apiDataTemas.loading? (apiDataTemas.data).length : "" ) + ")": "Topics" + " (" + (!apiDataTemas.loading? (apiDataTemas.data).length : "" ) + ")"}>
                          { !apiDataTemas.loading && apiDataTemas.data.map((datos,i) => (
                            <div className = "col-xs-12 col-sm-12 todo" key={datos.ID} style={{marginBottom:"5px"}} id={"resultadoGeneral-Temas-" + datos.ID}>
                              <div style={{paddingLeft: "0px!important", display:"inline-flex"}}  id={"titulo-" + datos.ID}>
                                {
                                      datos.TEMAS_URL !== "" ?
                                        <a target="_blank" href={datos.TEMAS_URL} id={"TituloHip-" + datos.ID}> 
                                          <div  id={"gadget-" + datos.ID}>
                                            {datos.TITULO_TEMAS} 
                                          </div>
                                        </a>
                                      :
                                        <div  id={"gadget-" + datos.ID}>
                                            {datos.TITULO_TEMAS} 
                                        </div>
                                    }
                              </div>
                            </div>
                          ))}
                        </Tab>)
                        :""
                      ):""
                    }
                  </Tabs>
                </div>
              </div>
              </>
            )
          :""
        }
      </>
  );
}